module.exports = __webpack_public_path__ + "img/Sew Eurodrive.99815131.png";